var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Enunciado:")]),_vm._v(" "),_c('div',{staticClass:"question-content",domProps:{"innerHTML":_vm._s(_vm.question.content)}}),_vm._v(" "),_c('AnswerList',{attrs:{"dinamic":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }